import React, { createContext, useContext, useState, useCallback } from 'react';

interface UpgradeModalState {
  show: boolean;
  highlightFeature: string | null;
  openUpgradeModal: (featureKey?: string) => void;
  closeUpgradeModal: () => void;
}

const UpgradeModalContext = createContext<UpgradeModalState>({
  show: false,
  highlightFeature: null,
  openUpgradeModal: () => {},
  closeUpgradeModal: () => {},
});

export const UpgradeModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [show, setShow] = useState(false);
  const [highlightFeature, setHighlightFeature] = useState<string | null>(null);

  const openUpgradeModal = useCallback((featureKey?: string) => {
    setHighlightFeature(featureKey ?? null);
    setShow(true);
  }, []);

  const closeUpgradeModal = useCallback(() => {
    setShow(false);
    setHighlightFeature(null);
  }, []);

  return (
    <UpgradeModalContext.Provider value={{ show, highlightFeature, openUpgradeModal, closeUpgradeModal }}>
      {children}
    </UpgradeModalContext.Provider>
  );
};

export function useUpgradeModal(): UpgradeModalState {
  return useContext(UpgradeModalContext);
}
